export default function () {
  return useState<string | undefined>('user-session-name', () => useUserState().value?.email?.split('@')?.[0])
}
